import {makeAutoObservable} from "mobx";
import type {InitiativeStatus} from "../../ApiTypes";
import type {Dayjs} from "dayjs";
import dayjs from "dayjs";
import type {InitiativeInstanceStore} from "./InitiativeInstanceStore";

export class InitiativeStatusController {
    constructor(public iis: InitiativeInstanceStore, public index: number) {
        makeAutoObservable(this);
    }

    get instance(): InitiativeStatus {
        return this.iis.instance.doi![this.index];
    }

    get dueDate() {
        return dayjs(this.instance.due_date);
    }

    set dueDate(value: Dayjs) {
        this.instance.due_date = value.toDate();
    }

    get actualDate(): Dayjs | null {
        return this.instance.actual_date ? dayjs(this.instance.actual_date) : null;
    }

    set actualDate(value: Dayjs | null) {
        this.instance.actual_date = value ? value.toDate() : null;
    }

    get presented(): boolean {
        return this.instance.presented ?? false;
    }

    set presented(value: boolean) {
        this.instance.presented = value;
        // Default the presentation date to today when first marked as presented
        if (value && !this.instance.presented_date)
            this.instance.presented_date = new Date();
        if (!value)
            this.instance.presented_date = null;
    }

    get presentedDate(): Dayjs | null {
        return this.instance.presented_date ? dayjs(this.instance.presented_date) : null;
    }

    set presentedDate(value: Dayjs | null) {
        this.instance.presented_date = value ? value.toDate() : null;
    }
}
